import axios from "axios";

export const generarGuion = async (unidadId, token, rut) => {
  const url = `${process.env.REACT_APP_URL_APP}guiones/generar/${unidadId}`;
  const config = {
    method: "post",
    url,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      rut: rut
    },

  };

  const response = await axios(config);
  return response.data;
};

export const obtenerGuion = async (unidadId, token) => {
  //const url = `${process.env.REACT_APP_URL_APP}guiones/${unidadId}`;
  const url = `${process.env.REACT_APP_URL_APP}guiones/obtener/${unidadId}`;
  const config = {
    method: "get",
    url,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  const response = await axios(config);
  return response.data.output;
};

export const obtenerVersionesGuion = async (unidadId, token) => {
  const url = `${process.env.REACT_APP_URL_APP}guiones/versiones/${unidadId}`;
  const config = {
    method: "get",
    url,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios(config);
  return response.data;
};

